import { render, staticRenderFns } from "./Firme.vue?vue&type=template&id=cc595312&scoped=true&"
import script from "./Firme.vue?vue&type=script&lang=js&"
export * from "./Firme.vue?vue&type=script&lang=js&"
import style0 from "./Firme.vue?vue&type=style&index=0&id=cc595312&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc595312",
  null
  
)

export default component.exports